export const MENTION_MENU_ANCHOR_CLASS_NAME = 'mention-menu-anchor';

export function shouldCloseOutsideMentionMenu(element: Element) {
  return !element.closest(`.${MENTION_MENU_ANCHOR_CLASS_NAME}`);
}
